export default __webpack_public_path__ + "static/media/proyecto3.55d192f3.jpg";